import giftCards from './giftCards'
import prepaidWallets from './prepaidWallets'

const card = {
  giftCards,
  prepaidWallets,
}

export default card
